import type { MarketingAttributionParams } from "./utm-params";
import { resolveMarketingAttributionParams } from "./utm-params";

const frontendUrl =
  process.env.NEXT_PUBLIC_FRONTEND_URL ?? "https://app.rivetai.com";

export function isFrontendAppUrl(href: string): boolean {
  try {
    const target = new URL(href);
    const frontend = new URL(frontendUrl);
    return target.origin === frontend.origin;
  } catch {
    return false;
  }
}

export function appendAttributionToUrl(
  href: string,
  attribution?: MarketingAttributionParams,
): string {
  if (!isFrontendAppUrl(href)) {
    return href;
  }

  const params =
    attribution ??
    (typeof window !== "undefined"
      ? resolveMarketingAttributionParams(
          new URLSearchParams(window.location.search),
        )
      : {});

  if (Object.keys(params).length === 0) {
    return href;
  }

  const url = new URL(href);

  for (const [key, value] of Object.entries(params)) {
    if (value && !url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  }

  return url.toString();
}
